import Toast from 'sbf-design-system-component/toasts/toast';
const $specialShare = $('.special-share');

const android = navigator.userAgent.toLowerCase().indexOf('android') > -1;
const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
const isMobile = android || iOS;
const useShareApi = isMobile && ('share' in navigator);

$(window).click((event) => {
  if (!event.target.matches('.special-share .share-button, .special-share .share-button *')) {
    $specialShare.removeClass('active');
  }
});
$specialShare.find('.share-button').click(async function (e) {
  const $el = $(this);
  e.preventDefault();
  const shareData = {
    text: $specialShare.attr('data-message'),
    url: $specialShare.attr('data-url')
  };

  if (useShareApi && navigator.canShare(shareData) && !$specialShare.hasClass('active')) {
    try {
      await navigator.share(shareData);
    } catch (err) {
      $specialShare.toggleClass('active');
    }
  } else {
    $specialShare.toggleClass('active');
  }
  $el.attr('aria-expanded', $specialShare.hasClass('active') ? 'true' : 'false');
});

// Twitter, Facebook, and SBF communicate share buttons
$specialShare.find('.twitter, .facebook, .linkedin').on('click', function (e) {
  e.preventDefault();
  shareWindow(this, 675, 500);
});

$specialShare.find('.communicate').on('click', function (e) {
  e.preventDefault();
  shareWindow(this, 425, 800);
});

if (!navigator.clipboard) {
  $specialShare.find('.copy').remove();
}
$specialShare.find('.copy').on('click', async function (e) {
  e.preventDefault();

  const errorMsg = `Copy action failed when attempting to copy:<br/>"<span class="sbf-toast__wrap-word">${this.href}</span>"<br/>Please check your browser settings and try again or copy the data manually.`;

  try {
    await navigator.clipboard.writeText(this.href);
    Toast.show('Link copied to clipboard.');
  } catch (e) {
    Toast.show(errorMsg, { type: 'error', htmlMessage: true });
  }
});

// Generate new window for twitter, facebook, and site sharing
function shareWindow (el, width = 0, height = 0) {
  $(el).focus();

  const left = ($(window).width() - width) / 2;
  const top = ($(window).height() - height) / 2;
  const url = el.href;
  const opts = `width=${width},height=${height},top=${top},left=${left}`;

  window.open(url, 'share', opts);
}
